export const RETAIL_ROUTE_NAMES = {
  retailEShops: 'accRetailEShops',
  retailWines: 'accRetailWines',
  myRange: 'accRetailMyRange',
  retailGeoIndications: 'accRetailGeoIndications',
  retailBuyersWine: 'accRetailBuyersWine',
  retailPriceReport: 'accRetailPriceReport',
}
